import ReactDOM from 'react-dom/client';
import App from './App';
import { PublicClientApplication, EventType, AccountInfo, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import ErrorBoundary from './interceptors/errorHandler';

export const msalInstance = new PublicClientApplication(msalConfig);
(window as any).msalInstance = msalInstance;

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
    }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<ErrorBoundary>
                    <App instance={msalInstance} />
            </ErrorBoundary>);
